<template>
	<div class="d-none sidebar" />
</template>

<script>
export default {
    name: 'BillingSidebar',
    data() {
        return {
        };
    },
}
</script>

<style lang="scss">
.sidebar {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #121212;
    color: #181818;
}
</style>